<template>
  <div>
    <AdminNav />
    <div class="page">
      <h2 class="page-title">Generateur de cartes fidelite</h2>
      <div class="card config-card">
        <div class="config-grid">
          <div class="form-group">
            <label class="label">Nom du commercant</label>
            <input v-model="config.nom" class="input" placeholder="Ex: Marche Herrera" />
          </div>
          <div class="form-group">
            <label class="label">Commercant</label>
            <select v-model="config.commercant_id" class="input" @change="chargerCartes">
              <option value="">Selectionner</option>
              <option v-for="c in commercants" :key="c.id" :value="c.id">{{ c.nom_enseigne }}</option>
            </select>
          </div>
          <div class="form-group">
            <label class="label">Numero de depart</label>
            <input v-model.number="config.debut" class="input" type="number" min="1" />
          </div>
          <div class="form-group">
            <label class="label">Nombre de cartes</label>
            <input v-model.number="config.nombre" class="input" type="number" min="1" max="200" />
          </div>
          <div class="form-group">
            <label class="label">Couleur principale</label>
            <div class="color-row">
              <input v-model="config.couleur" class="color-input" type="color" />
              <span class="color-hex">{{ config.couleur }}</span>
            </div>
          </div>
          <div class="form-group">
            <label class="label">Couleur accent</label>
            <div class="color-row">
              <input v-model="config.accent" class="color-input" type="color" />
              <span class="color-hex">{{ config.accent }}</span>
            </div>
          </div>
          <div class="form-group">
            <label class="label">Recompense verso</label>
            <input v-model="config.recompense" class="input" placeholder="100 PTS = 5 offerts" />
          </div>
          <div class="form-group">
            <label class="label">QR top (mm)</label>
            <input v-model.number="config.qrTop" class="input" type="number" step="10" />
          </div>
          <div class="form-group">
            <label class="label">QR right (mm)</label>
            <input v-model.number="config.qrRight" class="input" type="number" step="0.5" />
          </div>
          <div class="form-group">
            <label class="label">QR taille (mm)</label>
            <input v-model.number="config.qrSize" class="input" type="number" step="0.5" />
          </div>
          <div class="form-group">
            <label class="label">N bottom (mm)</label>
            <input v-model.number="config.numBottom" class="input" type="number" step="3" />
          </div>
          <div class="form-group">
            <label class="label">N left (mm)</label>
            <input v-model.number="config.numLeft" class="input" type="number" step="0.5" />
          </div>
          <div class="form-group">
            <label class="label">Couleur N de carte</label>
            <div class="color-row"><input v-model="config.numColor" class="color-input" type="color" /><span class="color-hex">{{ config.numColor }}</span></div>
          </div>
        </div>
        <div class="btn-row">
          <button class="btn btn-secondary" @click="previsualiser" :disabled="!config.nom || loading">
            Previsualiser
          </button>
          <button class="btn btn-primary" @click="creerCartes" :disabled="!config.commercant_id || loading">
            {{ loading ? 'Generation...' : 'Valider et creer les cartes' }}
          </button>
          <button class="btn btn-secondary" @click="imprimer" v-if="cartes.length">Imprimer recto/verso</button>
        </div>
        <p class="success-message" v-if="message">{{ message }}</p>
        <p class="error-message" v-if="erreur">{{ erreur }}</p>
      </div>

      <div id="zone-impression" v-if="cartes.length">
        <div v-for="(page, pi) in pages" :key="pi">
          <div class="page-a4">
            <div class="page-label-screen">RECTO - Feuille {{ pi + 1 }}</div>
            <div class="grille-a4">
              <div class="carte-recto" v-for="carte in page" :key="'r'+carte.key">
                <img src="https://fidmarket.fr/carte-recto.png" class="cr-bg-img" />
                <div class="cr-qr" :style="{ top: config.qrTop+'mm', right: config.qrRight+'mm', width: config.qrSize+'mm', height: config.qrSize+'mm' }">
                  <img v-if="carte.qrPublic" :src="carte.qrPublic" :style="{ width: config.qrSize+'mm', height: config.qrSize+'mm' }" />
                  <div v-else class="cr-qr-missing" :style="{ width: config.qrSize+'mm', height: config.qrSize+'mm' }">
                    QR genere apres validation
                  </div>
                </div>
                <div class="cr-num" :style="{ bottom: config.numBottom+'mm', left: config.numLeft+'mm', color: config.numColor }">
                  <div class="cr-num-label">N DE CARTE</div>
                  <div class="cr-num-val">{{ carte.numero }}</div>
                  <div class="cr-client" v-if="carte.nomClient">{{ carte.nomClient }}</div>
                </div>
              </div>
              <div class="carte-vide" v-for="n in (8 - page.length)" :key="'v'+n"></div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminNav from '../../components/AdminNav.vue'
import adminApi from '../../adminApi'
import QRCode from 'qrcode'

export default {
  name: 'AdminCartes',
  components: { AdminNav },
  data() {
    return {
      config: { nom: 'Marche Herrera', commercant_id: '', recompense: '100 PTS = 5 OFFERTS', debut: 1, nombre: 8, couleur: '#1a3a6b', accent: '#4a9b4e', qrTop: 5, qrRight: 5.8, qrSize: 14, numBottom: 1, numLeft: 2, numColor: '#ffffff' },
      commercants: [],
      cartes: [],
      loading: false,
      erreur: '',
      message: ''
    }
  },
  computed: {
    pages() {
      const r = []
      for (let i = 0; i < this.cartes.length; i += 8) r.push(this.cartes.slice(i, i + 8))
      return r
    }
  },
  methods: {
    numeroFormat(n) { return String(n).padStart(6, '0') },
    urlCartePublique(token) {
      const baseUrl = window.location.origin.replace(/\/$/, '')
      return `${baseUrl}/carte/${encodeURIComponent(token)}`
    },
    getCarteQrValue(carte) {
      const token = String(carte.public_token || '').trim()
      const qrUrl = String(carte.qr_url || '').trim()
      if (qrUrl) return qrUrl
      if (token) return this.urlCartePublique(token)
      return ''
    },
    nomClient(carte) {
      return [carte.prenom, carte.nom].filter(Boolean).join(' ').trim()
    },
    async genererQrPublic(carte) {
      const qrValue = this.getCarteQrValue(carte)
      if (!qrValue) return ''

      return QRCode.toDataURL(qrValue, {
        width: 180,
        margin: 1,
        color: {
          dark: '#1a3a6b',
          light: '#ffffff'
        }
      })
    },
    async chargerCommercants() {
      try {
        const res = await adminApi.get('/commercants')
        this.commercants = res.data || []
        if (!this.config.commercant_id && this.commercants.length === 1) {
          this.config.commercant_id = this.commercants[0].id
          this.config.nom = this.commercants[0].nom_enseigne || this.config.nom
        }
      } catch {
        this.commercants = []
      }
    },
    async chargerCartes() {
      this.loading = true
      this.erreur = ''
      this.message = ''
      try {
        const res = await adminApi.get('/cartes', {
          params: {
            debut: this.config.debut,
            nombre: this.config.nombre,
            commercant_id: this.config.commercant_id || undefined
          }
        })
        this.cartes = await this.normaliserCartesApi(res.data)
      } catch (err) {
        this.cartes = []
        this.erreur = err.response?.data?.error || 'Impossible de charger les cartes.'
      } finally {
        this.loading = false
      }
    },
    async previsualiser() {
      this.erreur = ''
      this.message = 'Previsualisation non enregistree : validez pour creer les cartes et obtenir les QR.'
      const debut = Number(this.config.debut)
      const nombre = Number(this.config.nombre)
      this.cartes = Array.from({ length: nombre }, (_, index) => {
        const numero = this.numeroFormat(debut + index)
        return {
          key: `preview-${numero}-${index}`,
          numero,
          nomClient: '',
          public_token: '',
          qr_url: '',
          statut: 'previsualisation',
          preview: true,
          qrPublic: ''
        }
      })
    },
    async creerCartes() {
      this.loading = true
      this.erreur = ''
      this.message = ''
      try {
        const res = await adminApi.post('/cartes/generer', {
          numero_depart: this.config.debut,
          nombre_cartes: this.config.nombre,
          type: 'digitale',
          commercant_id: this.config.commercant_id
        })
        this.cartes = await this.normaliserCartesApi(res.data.cards || [])
        this.message = `${res.data.created_count ?? res.data.created ?? 0} carte(s) creee(s), ${res.data.existing_count ?? res.data.skipped ?? 0} deja existante(s).`
      } catch (err) {
        this.erreur = err.response?.data?.error || 'Impossible de creer les cartes.'
      } finally {
        this.loading = false
      }
    },
    async normaliserCartesApi(cartesApi) {
      return Promise.all((cartesApi || []).map(async (carte, index) => {
        const numero = String(carte.numero_carte || this.numeroFormat(Number(this.config.debut) + index))
        const publicToken = String(carte.public_token || '').trim()
        const qrUrl = String(carte.qr_url || '').trim()
        return {
          key: `${numero}-${carte.client_id || publicToken || index}`,
          numero,
          nomClient: this.nomClient(carte),
          public_token: publicToken,
          qr_url: qrUrl,
          type: carte.type || 'digitale',
          actif: Boolean(carte.actif),
          preview: false,
          qrPublic: await this.genererQrPublic({ ...carte, public_token: publicToken, qr_url: qrUrl })
        }
      }))
    },
    imprimer() { window.print() }
  },
  async mounted() {
    await this.chargerCommercants()
    await this.chargerCartes()
  }
}
</script>

<style scoped>
.page { padding: 24px; max-width: 1200px; margin: 0 auto; }
.page-title { font-size: 22px; font-weight: 700; margin-bottom: 20px; }
.card { background: white; border-radius: 14px; padding: 20px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); margin-bottom: 20px; }
.config-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 14px; margin-bottom: 14px; }
.form-group { display: flex; flex-direction: column; gap: 5px; }
.label { font-size: 12px; font-weight: 600; color: #4a5568; }
.input { padding: 9px 12px; border: 1.5px solid #e2e8f0; border-radius: 8px; font-size: 13px; outline: none; width: 100%; box-sizing: border-box; }
.color-row { display: flex; align-items: center; gap: 8px; }
.color-input { width: 44px; height: 36px; border: 1.5px solid #e2e8f0; border-radius: 6px; padding: 2px; cursor: pointer; }
.color-hex { font-family: monospace; font-size: 12px; color: #718096; }
.btn-row { display: flex; gap: 10px; margin-top: 14px; }
.btn { padding: 10px 20px; border-radius: 10px; border: none; font-size: 14px; font-weight: 600; cursor: pointer; }
.btn-primary { background: #2d3748; color: white; }
.btn-primary:disabled { background: #a0aec0; cursor: not-allowed; }
.btn-secondary { background: #edf2f7; color: #4a5568; }
.error-message { margin: 10px 0 0; color: #c53030; font-size: 13px; font-weight: 600; }
.success-message { margin: 10px 0 0; color: #166534; font-size: 13px; font-weight: 600; }
.page-a4 { width: 210mm; min-height: 297mm; background: white; margin: 0 auto 8px; padding: 8mm; box-sizing: border-box; box-shadow: 0 4px 20px rgba(0,0,0,0.12); border-radius: 4px; }

.page-label-screen { font-size: 11px; font-weight: 700; color: #a0aec0; margin-bottom: 6mm; text-align: center; }
.grille-a4 { display: grid; grid-template-columns: 85.6mm 85.6mm; gap: 4mm; justify-content: center; }
.carte-vide { width: 85.6mm; height: 54mm; }
.carte-recto { width: 85.6mm; height: 54mm; border-radius: 3mm; overflow: hidden; box-sizing: border-box; position: relative; }
.cr-bg { position: absolute; inset: 0; }
.cr-bg-img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: fill; display: block; }
.cr-qr { position: absolute; display: flex; align-items: center; justify-content: center; }
.cr-qr img { display: block; }
.cr-qr-missing { display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 1mm; background: #fff; border: 0.25mm solid #c53030; color: #c53030; font-size: 3pt; line-height: 1.15; text-align: center; font-weight: 800; text-transform: uppercase; }
.cr-num { position: absolute; display: flex; flex-direction: column; }
.cr-num-label { font-size: 3pt; color: inherit; text-transform: uppercase; letter-spacing: 0.5pt; font-weight: 700; margin-bottom: 0.5mm; }
.cr-num-val { font-size: 9pt; font-weight: 900; color: inherit; letter-spacing: 1pt; font-family: monospace; }
.cr-client { max-width: 40mm; margin-top: 0.5mm; font-size: 3.2pt; font-weight: 700; color: inherit; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.carte-verso { width: 85.6mm; height: 54mm; border-radius: 3mm; border: 0.3mm solid #ddd; display: grid; grid-template-columns: 1.1fr 0.9fr 8mm 8mm; overflow: hidden; box-sizing: border-box; font-family: Arial, Helvetica, sans-serif; background: var(--couleur); color: white; }
.cv-left { padding: 2mm; display: flex; flex-direction: column; justify-content: center; border-right: 0.3mm solid rgba(255,255,255,0.12); overflow: hidden; }
.cv-titre { font-size: 4.5pt; font-weight: 900; text-transform: uppercase; }
.cv-italic { font-size: 7pt; font-style: italic; color: var(--accent); font-weight: 700; margin: 0.5mm 0; }
.cv-desc { font-size: 3.5pt; opacity: 0.8; line-height: 1.4; }
.cv-center { padding: 2mm; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; border-right: 0.3mm solid rgba(255,255,255,0.12); }
.cv-recompense { font-size: 4.5pt; font-weight: 800; color: var(--accent); text-transform: uppercase; margin-bottom: 1mm; }
.cv-panier { font-size: 12pt; }
.cv-qr-col { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 1mm 0.5mm; gap: 0.8mm; border-left: 0.3mm solid rgba(255,255,255,0.12); }
.cv-qr-tag { font-size: 3pt; font-weight: 700; color: rgba(255,255,255,0.9); text-align: center; white-space: nowrap; }
.cv-qr-tag-green { color: var(--accent); }
.cv-qr-box { background: white; border-radius: 1mm; padding: 0.5mm; }
.cv-qr-bleu { border: 0.4mm solid var(--couleur); }
.cv-qr-vert { border: 0.4mm solid var(--accent); }
.cv-qr-img { width: 9mm; height: 9mm; display: block; }
.cv-qr-num { font-size: 3pt; font-weight: 900; font-family: monospace; color: white; }
.cv-qr-hint { font-size: 2.8pt; color: var(--accent); text-align: center; font-weight: 600; }
@media print {
  @page { size: A4 portrait; margin: 8mm; }
  .page-title, .config-card, .page-label-screen { display: none !important; }
  .page { padding: 0 !important; max-width: none !important; margin: 0 !important; }
  .page-a4 { width: 100%; min-height: auto; margin: 0; padding: 0; box-shadow: none; border-radius: 0; page-break-after: always; break-after: page; }
  .page-a4:last-child { page-break-after: avoid; break-after: avoid; }
  
  .grille-a4 { display: grid; grid-template-columns: 85.6mm 85.6mm; gap: 3mm; justify-content: center; padding: 4mm 0; }
  .carte-recto { width: 85.6mm !important; height: 54mm !important; break-inside: avoid; page-break-inside: avoid; }
  * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; color-adjust: exact !important; }
}
</style>

<style>
@media print {
  nav.admin-nav { display: none !important; }
  nav.navbar { display: none !important; }
  .bottom-nav { display: none !important; }
}
</style>
